import {Container, Row, Col} from 'react-bootstrap';
import {useLanguageContext, useThemeContext} from '../../../context';
import List from './List';
import withObservables from '@nozbe/with-observables';
import NonIdealScreen from '../NonIdeal';
import {useNavigate} from 'react-router-dom';
import {PosAppModal} from '../V2';
import SearchBox from '../SearchBox';
import {useSearch} from '../../../hooks';
import usePermission from '../../../hooks/usePermission';
import {observeUnArchivedDiscounts} from '../../../pos-core/database/helpers';

const PosDiscountModal = ({toggle, setToggle, discounts, handleSelect, order}) => {
    const navigate = useNavigate();
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    const {text, setText, searchList} = useSearch(handleSearch);
    const userPermission = usePermission('discounts');

    const handleClose = event => {
        setToggle(false);
    };

    const handleCreateDiscount = () => {
        navigate('/discounts/create');
    };

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';

        setText(value);
    };

    function handleSearch(val) {
        return discounts.filter(x => x.name.toLowerCase().includes(val.toLowerCase()));
    }

    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            rightCta={
                discounts?.length && {
                    title: I18n.create_discount,
                    action: handleCreateDiscount,
                    iconName: 'add2Icon',
                    fill: theme.barclaysBlue,
                    width: '18',
                    height: '18',
                    viewBox: '0 0 18 18',
                }
            }
            title={I18n.order_discount}>
            <>
                {!discounts.length == 0 && (
                    <SearchBox
                        type="pos"
                        placeholder={I18n.search_discounts_by_name}
                        prefix={{
                            name: 'search2Icon',
                            fill: theme.white,
                        }}
                        onChange={onChange}
                    />
                )}

                <Container fluid>
                    <Row className="justify-content-md-center">
                        <Col md={12}>
                            {discounts.length ? (
                                <section className="addScreenMainBox">
                                    <Container>
                                        <Row className="justify-content-md-center">
                                            <Col md={12}>
                                                {(text ? searchList : discounts).map((val, index) => (
                                                    <List key={index} discounts={val} order={order} handleClick={handleSelect} />
                                                ))}
                                            </Col>
                                        </Row>
                                    </Container>
                                </section>
                            ) : (
                                <NonIdealScreen
                                    heading={I18n.discount}
                                    subHeading={I18n.discount_credit_cards_entire_orders}
                                    name="discountIcon"
                                    fill={theme.white}
                                    primaryCta={
                                        userPermission?.canCrud
                                            ? {
                                                  title: I18n.create_discount,
                                                  action: handleCreateDiscount,
                                              }
                                            : null
                                    }
                                    isMultiStep={false}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        </PosAppModal>
    );
};

const enhance = withObservables([], () => ({
    discounts: observeUnArchivedDiscounts(),
}));

export default enhance(PosDiscountModal);
